import { render, staticRenderFns } from "./quanxianpeizhi.vue?vue&type=template&id=216d9756&scoped=true&"
import script from "./quanxianpeizhi.vue?vue&type=script&lang=js&"
export * from "./quanxianpeizhi.vue?vue&type=script&lang=js&"
import style0 from "./quanxianpeizhi.vue?vue&type=style&index=0&id=216d9756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d9756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCardSubtitle,VCardText,VSheet,VTreeview})
